import { z } from 'zod';
import { getMutationSchema } from '../../../../ui/util/getMutationSchema';
import { ResourceType } from '../../../enumerations/ResourceType';
import { useIndirectlyVersionedResourceAdapter } from '../../../resource-base/adapters/useIndirectlyVersionedResourceAdapter';
import { useMultiResourceSingleParentedResourceAdapterActions } from '../../../resource-base/adapters/useMultiResourceSingleParentedResourceAdapterActions';
import {
    defaultIndirectlyVersionedArtifactResource,
    IndirectlyVersionedArtifactResourceSchema,
} from '../../../resource-base/artifactResourceTypes';
import { IdSchema } from '../../../resource-base/baseSchemas';

export enum UseCaseWorkflowAssociationRepresentationPropertyValidation {
    WORKFLOW = 'WORKFLOW',
}

export const UseCaseWorkflowAssociationRepresentationResourceSchema = IndirectlyVersionedArtifactResourceSchema.extend({
    resourceType: z
        .literal(ResourceType.USE_CASE_WORKFLOW_REPRESENTATION_ASSOCIATION)
        .default(ResourceType.USE_CASE_WORKFLOW_REPRESENTATION_ASSOCIATION),
    workflowRepresentation: IdSchema,
});
export const UseCaseWorkflowAssociationRepresentationMutationResourceSchema = getMutationSchema(
    UseCaseWorkflowAssociationRepresentationResourceSchema
);

export type UseCaseWorkflowAssociationRepresentationResource = z.infer<
    typeof UseCaseWorkflowAssociationRepresentationResourceSchema
>;

export const defaultUseCaseWorkflowAssociationRepresentationResource: UseCaseWorkflowAssociationRepresentationResource =
    {
        ...defaultIndirectlyVersionedArtifactResource,
        resourceType: ResourceType.USE_CASE_WORKFLOW_REPRESENTATION_ASSOCIATION,
        workflowRepresentation: '',
    };

export function useUseCaseWorkflowAssociationRepresentationActions() {
    return {
        ...useMultiResourceSingleParentedResourceAdapterActions(
            'project/use-case-workflow-representation-association',
            ResourceType.USE_CASE_WORKFLOW_REPRESENTATION_ASSOCIATION,
            UseCaseWorkflowAssociationRepresentationResourceSchema
        ),
        ...useIndirectlyVersionedResourceAdapter(
            'project/use-case-workflow-representation-association',
            ResourceType.USE_CASE_WORKFLOW_REPRESENTATION_ASSOCIATION,
            UseCaseWorkflowAssociationRepresentationResourceSchema
        ),
    };
}
